import RestModule from "../RestModule";

export default new RestModule("payment_methods", {});
